
(function () {
  // get everyday opertaror from session storage
  const everydayOperator = sessionStorage.getItem('everyday-operator-viewed');

  if (everydayOperator) {

    // create div element
    const div = document.createElement('div');
    div.classList.add('eo-breadcrumbs');
    div.innerHTML = `<div class="eo-breadcrumbs-inner">
                      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
                        <path d="m20.5 21.464-.75.433-6-3.464v-.866l6-3.464.75.433v6.928Z" stroke="currentColor" stroke-linejoin="bevel"/>
                      </svg>
                      <a href="/everyday-operator">
                        <img class="edo-logo" src="https://cdn.shopify.com/s/files/1/0591/0164/2941/files/EO_Logo_Fill.svg?v=1723109617">
                      </a>
                    </div>`;
    
    // append div element to the body
    document.querySelector('.lyt-Site_Main').insertAdjacentElement('beforeBegin', div);

    // set product_inspired_by in session storage
    sessionStorage.setItem('product_inspired_by', everydayOperator);

    // remove everydayOperator from session storage
    sessionStorage.removeItem('everyday-operator-viewed');

  } else {
    sessionStorage.removeItem('product_inspired_by');
  }

})();
